var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "briefcase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconen-drukke-dagen",
    transform: "translate(-122.000000, -48.000000)",
    fill: "#FF8100",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(122.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L12,0 C13.1045695,0 14,0.8954305 14,2 L14,4 L18,4 C19.1045695,4 20,4.8954305 20,6 L20,17 C20,18.1045695 19.1045695,19 18,19 L2,19 C0.89,19 0,18.1 0,17 L0,6 C0,4.89 0.89,4 2,4 L6,4 L6,2 C6,0.89 6.89,0 8,0 M12,4 L12,2 L8,2 L8,4 L12,4 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ec37e96829b29203e9c33d9e42b3cd56.svg";
export { ForwardRef as ReactComponent };